let sceneType = {};

sceneType.getData = function() {
	var data = [
		{
			value : 1000,
			name : "其他",
		},
		{
			value : 1001,
			name : "发现栏小程序主入口，「最近使用」列表（基础库2.2.4版本起包含「我的小程序」列表）",
		},
		{
			value : 1005,
			name : "微信首页顶部搜索框的搜索结果页",
		},
		{
			value : 1006,
			name : "发现栏小程序主入口搜索框的搜索结果页",
		},
		{
			value : 1007,
			name : "单人聊天会话中的小程序消息卡片",
		},
		{
			value : 1008,
			name : "群聊会话中的小程序消息卡片",
		},
		{
			value : 1010,
			name : "收藏夹",
		},
		{
			value : 1011,
			name : "扫描二维码",
		},
		{
			value : 1012,
			name : "长按图片识别二维码",
		},
		{
			value : 1013,
			name : "扫描手机相册中选取的二维码",
		},
		{
			value : 1014,
			name : "小程序订阅消息（与1107相同）",
		},
		{
			value : 1017,
			name : "前往小程序体验版的入口页",
		},
		{
			value : 1019,
			name : "微信钱包（微信客户端7.0.0版本改为支付入口）",
		},
		{
			value : 1020,
			name : "公众号 profile 页相关小程序列表（已废弃）",
		},
		{
			value : 1022,
			name : "聊天顶部置顶小程序入口（微信客户端6.6.1版本起废弃）",
		},
		{
			value : 1023,
			name : "安卓系统桌面图标",
		},
		{
			value : 1024,
			name : "小程序 profile 页",
		},
		{
			value : 1025,
			name : "扫描一维码",
		},
		{
			value : 1026,
			name : "发现栏小程序主入口，「附近的小程序」列表",
		},
		{
			value : 1027,
			name : "微信首页顶部搜索框搜索结果页「使用过的小程序」列表",
		},
		{
			value : 1028,
			name : "我的卡包",
		},
		{
			value : 1029,
			name : "小程序中的卡券详情页",
		},
		{
			value : 1030,
			name : "自动化测试下打开小程序",
		},
		{
			value : 1031,
			name : "长按图片识别一维码",
		},
		{
			value : 1032,
			name : "扫描手机相册中选取的一维码",
		},
		{
			value : 1034,
			name : "微信支付完成页",
		},
		{
			value : 1035,
			name : "公众号自定义菜单",
		},
		{
			value : 1036,
			name : "App 分享消息卡片",
		},
		{
			value : 1037,
			name : "小程序打开小程序",
		},
		{
			value : 1038,
			name : "从另一个小程序返回",
		},
		{
			value : 1039,
			name : "摇电视",
		},
		{
			value : 1042,
			name : "添加好友搜索框的搜索结果页",
		},
		{
			value : 1043,
			name : "公众号模板消息",
		},
		{
			value : 1044,
			name : "带 shareTicket 的小程序消息卡片 详情",
		},
		{
			value : 1045,
			name : "朋友圈广告",
		},
		{
			value : 1046,
			name : "朋友圈广告详情页",
		},
		{
			value : 1047,
			name : "扫描小程序码",
		},
		{
			value : 1048,
			name : "长按图片识别小程序码",
		},
		{
			value : 1049,
			name : "扫描手机相册中选取的小程序码",
		},
		{
			value : 1052,
			name : "卡券的适用门店列表",
		},
		{
			value : 1053,
			name : "搜一搜的结果页",
		},
		{
			value : 1054,
			name : "顶部搜索框小程序快捷入口（微信客户端版本6.7.4起废弃）",
		},
		{
			value : 1056,
			name : "聊天顶部音乐播放器右上角菜单",
		},
		{
			value : 1057,
			name : "钱包中的银行卡详情页",
		},
		{
			value : 1058,
			name : "公众号文章",
		},
		{
			value : 1059,
			name : "体验版小程序绑定邀请页",
		},
		{
			value : 1060,
			name : "微信支付完成页（与1034相同）",
		},
		{
			value : 1064,
			name : "微信首页连 Wi-Fi 状态栏",
		},
		{
			value : 1065,
			name : "URL scheme 详情",
		},
		{
			value : 1067,
			name : "公众号文章广告",
		},
		{
			value : 1068,
			name : "附近小程序列表广告（已废弃）",
		},
		{
			value : 1069,
			name : "移动应用通过 openSDK 进入微信，打开小程序",
		},
		{
			value : 1071,
			name : "钱包中的银行卡列表页",
		},
		{
			value : 1072,
			name : "二维码收款页面",
		},
		{
			value : 1073,
			name : "客服消息列表下发的小程序消息卡片",
		},
		{
			value : 1074,
			name : "公众号会话下发的小程序消息卡片",
		},
		{
			value : 1077,
			name : "摇周边",
		},
		{
			value : 1078,
			name : "微信连 Wi-Fi 成功提示页",
		},
		{
			value : 1079,
			name : "微信游戏中心",
		},
		{
			value : 1081,
			name : "客服消息下发的文字链",
		},
		{
			value : 1082,
			name : "公众号会话下发的文字链",
		},
		{
			value : 1084,
			name : "朋友圈广告原生页",
		},
		{
			value : 1088,
			name : "会话中查看系统消息，打开小程序",
		},
		{
			value : 1089,
			name : "微信聊天主界面下拉，「最近使用」栏（基础库2.2.4版本起包含「我的小程序」栏）",
		},
		{
			value : 1090,
			name : "长按小程序右上角菜单唤出最近使用历史",
		},
		{
			value : 1091,
			name : "公众号文章商品卡片",
		},
		{
			value : 1092,
			name : "城市服务入口",
		},
		{
			value : 1095,
			name : "小程序广告组件",
		},
		{
			value : 1096,
			name : "聊天记录，打开小程序",
		},
		{
			value : 1097,
			name : "微信支付签约原生页，打开小程序",
		},
		{
			value : 1099,
			name : "页面内嵌插件",
		},
		{
			value : 1100,
			name : "红包封面详情页打开小程序",
		},
		{
			value : 1101,
			name : "远程调试热更新（开发者工具中，预览 -> 自动预览 -> 编译并预览）",
		},
		{
			value : 1102,
			name : "公众号 profile 页服务预览",
		},
		{
			value : 1103,
			name : "发现栏小程序主入口，「我的小程序」列表（基础库2.2.4版本起废弃）",
		},
		{
			value : 1104,
			name : "微信聊天主界面下拉，「我的小程序」栏（基础库2.2.4版本起废弃）",
		},
		{
			value : 1106,
			name : "聊天主界面下拉，从顶部搜索结果页，打开小程序",
		},
		{
			value : 1107,
			name : "订阅消息，打开小程序",
		},
		{
			value : 1113,
			name : "安卓手机负一屏，打开小程序（三星）",
		},
		{
			value : 1114,
			name : "安卓手机侧边栏，打开小程序（三星）",
		},
		{
			value : 1119,
			name : "【企业微信】工作台内打开小程序",
		},
		{
			value : 1120,
			name : "【企业微信】个人资料页内打开小程序",
		},
		{
			value : 1121,
			name : "【企业微信】聊天加号附件框内打开小程序",
		},
		{
			value : 1124,
			name : "扫“一物一码”打开小程序",
		},
		{
			value : 1125,
			name : "长按图片识别“一物一码”",
		},
		{
			value : 1126,
			name : "扫描手机相册中选取的“一物一码”",
		},
		{
			value : 1129,
			name : "微信爬虫访问",
		},
		{
			value : 1131,
			name : "浮窗（8.0版本起仅包含被动浮窗）",
		},
		{
			value : 1133,
			name : "硬件设备打开小程序",
		},
		{
			value : 1135,
			name : "小程序 profile 页相关小程序列表，打开小程序",
		},
		{
			value : 1144,
			name : "公众号文章 - 视频贴片",
		},
		{
			value : 1145,
			name : "发现栏 - 发现小程序",
		},
		{
			value : 1146,
			name : "地理位置信息打开出行类小程序",
		},
		{
			value : 1148,
			name : "卡包 - 交通卡，打开小程序",
		},
		{
			value : 1150,
			name : "扫一扫商品条码结果页打开小程序",
		},
		{
			value : 1151,
			name : "发现栏 - 我的订单",
		},
		{
			value : 1152,
			name : "订阅号视频打开小程序",
		},
		{
			value : 1153,
			name : "“识物”结果页打开小程序",
		},
		{
			value : 1154,
			name : "朋友圈内打开“单页模式”",
		},
		{
			value : 1155,
			name : "“单页模式”打开小程序",
		},
		{
			value : 1157,
			name : "服务号会话页打开小程序",
		},
		{
			value : 1158,
			name : "群工具打开小程序",
		},
		{
			value : 1160,
			name : "群待办",
		},
		{
			value : 1167,
			name : "H5 通过开放标签打开小程序",
		},
		{
			value : 1168,
			name : "移动应用直接运行小程序",
		},
		{
			value : 1169,
			name : "发现栏小程序主入口，各个生活服务入口（例如快递服务、出行服务等）",
		},
		{
			value : 1171,
			name : "微信运动记录（仅安卓）",
		},
		{
			value : 1173,
			name : "聊天素材用小程序打开",
		},
		{
			value : 1175,
			name : "视频号主页商店入口",
		},
		{
			value : 1176,
			name : "视频号直播间主播打开小程序",
		},
		{
			value : 1177,
			name : "视频号直播商品",
		},
		{
			value : 1178,
			name : "在电脑打开手机上打开的小程序",
		},
		{
			value : 1179,
			name : "#话题页打开小程序",
		},
		{
			value : 1181,
			name : "网站应用打开 PC 小程序",
		},
		{
			value : 1183,
			name : "PC微信 - 小程序面板 - 发现小程序 - 搜索",
		},
		{
			value : 1184,
			name : "视频号链接打开小程序",
		},
		{
			value : 1185,
			name : "群公告",
		},
		{
			value : 1186,
			name : "收藏 - 笔记",
		},
		{
			value : 1187,
			name : "浮窗（8.0版本起）",
		},
		{
			value : 1189,
			name : "表情雨广告",
		},
		{
			value : 1191,
			name : "视频号活动",
		},
		{
			value : 1192,
			name : "企业微信联系人 profile 页",
		},
		{
			value : 1193,
			name : "视频号主页服务菜单打开小程序",
		},
		{
			value : 1194,
			name : "URL Link 详情",
		},
		{
			value : 1195,
			name : "视频号主页商品tab",
		},
		{
			value : 1196,
			name : "个人状态打开小程序",
		},
		{
			value : 1197,
			name : "视频号主播从直播间返回小游戏",
		},
		{
			value : 1198,
			name : "视频号开播界面打开小游戏",
		},
		{
			value : 1201,
			name : "视频号广告详情页打开小程序",
		},
		{
			value : 1202,
			name : "企微客服号会话打开小程序卡片",
		},
		{
			value : 1203,
			name : "微信小程序压测工具的请求",
		},
		{
			value : 1206,
			name : "视频号小游戏直播间打开小游戏",
		},
		{
			value : 1207,
			name : "企微客服号会话打开小程序文字链",
		},
		{
			value : 1208,
			name : "聊天打开商品卡片",
		},
		{
			value : 1212,
			name : "青少年模式申请页打开小程序",
		},
		{
			value : 1215,
			name : "广告预约打开小程序",
		},
		{
			value : 1216,
			name : "视频号订单中心打开小程序",
		},
	];
	return data;
};

export default sceneType;



// WEBPACK FOOTER //
// ./src/utils/SceneType.js